<template>
  <div class="bCoupons">
    <div class="bCoupons__container container pt-4">
      <div class="bCoupons__header row">
        <div class="bCoupons__header__h2 h2 col">優惠券管理</div>
      </div>
      <div class="bCoupons__body row">
        <div class="col-6 mb-2"
        v-for="(item, index) in coupons"
        :key="index">
          <b-button
          v-b-toggle="item.id"
          class="my-1 w-100 d-flex flex-wrap align-items-center">
            <span class="col">
              {{item.description}}
            </span>
          </b-button>
          <b-collapse :id="item.id">
            <b-card>
              <form @submit.prevent="complete_editing(index)">
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  優惠券id</h6>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="!item.editing">
                    {{item.id}}
                  </div>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="item.editing">
                    <input type="text" class="form-control"
                    v-model="item.id"
                    required>
                  </div>
                </div>
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  優惠券描述</h6>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="!item.editing">
                    {{item.description}}
                  </div>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="item.editing">
                    <input type="text" class="form-control"
                    v-model="item.description"
                    required>
                  </div>
                </div>
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  折扣方式</h6>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="!item.editing">
                    {{convert_discount_method(item.discount_method)}}
                  </div>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="item.editing">
                    <select class="form-control"
                    v-model="item.method"
                    required>
                      <option value="" disabled>折扣方式</option>
                      <option value="minus">原價減去</option>
                      <option value="times">原價打折</option>
                    </select>
                  </div>
                </div>
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  折扣基數</h6>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="!item.editing">
                    {{item.discount_index}}
                  </div>
                  <div class="card-text mb-3 mb-md-0"
                  v-if="item.editing">
                    <input type="number" class="form-control"
                    v-if="item.discount_method === 'minus'"
                    min="1"
                    step="1"
                    v-model="item.discount_index"
                    required>
                    <input type="number" class="form-control"
                    v-if="item.discount_method === 'times'"
                    min="0"
                    max="1"
                    step="0.1"
                    v-model="item.discount_index"
                    required>
                  </div>
                </div>
                <hr>
                <div class="card-body p-0 d-flex justify-content-end">
                  <button class="btn btn-info mr-3" type="button"
                  @click.prevent="start_editing(index)"
                  v-if="!item.editing">
                    編輯優惠券
                  </button>
                  <button class="btn btn-success mr-3" type="submit"
                  v-if="item.editing">
                    儲存變更
                  </button>
                  <button class="btn btn-warning mr-3" type="button"
                  @click.prevent="initialize_coupons"
                  v-if="item.editing">
                    放棄變更
                  </button>
                  <button class="btn btn-danger" type="button"
                  @click.prevent="delete_coupon(index)">
                    刪除優惠券
                  </button>
                </div>
              </form>
            </b-card>
          </b-collapse>
        </div>
        <div class="col-6 mb-2">
          <b-button
          variant="primary"
          v-b-toggle="'newCoupon'"
          class="my-1 w-100 d-flex flex-wrap align-items-center">
            <span class="col">
              新增優惠券
            </span>
          </b-button>
          <b-collapse id="newCoupon">
            <b-card>
              <form @submit.prevent="submit_new_coupon">
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  優惠券id</h6>
                  <div class="card-text mb-3 mb-md-0">
                    <input type="text" class="form-control"
                    v-model="newCoupon.id"
                    required>
                  </div>
                </div>
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  優惠券描述</h6>
                  <div class="card-text mb-3 mb-md-0">
                    <input type="text" class="form-control"
                    v-model="newCoupon.description"
                    required>
                  </div>
                </div>
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  折扣方式</h6>
                  <div class="card-text mb-3 mb-md-0">
                    <select class="form-control"
                    v-model="newCoupon.discount_method"
                    required>
                      <option value="" disabled>折扣方式</option>
                      <option value="minus">原價減去</option>
                      <option value="times">原價打折</option>
                    </select>
                  </div>
                </div>
                <div class="card-body p-0 mb-md-3
                d-flex flex-column flex-md-row align-items-md-center">
                  <h6 class="card-title
                  text-md-right pr-md-3 mb-md-0">
                  折扣基數</h6>
                  <div class="card-text mb-3 mb-md-0">
                    <input type="number" class="form-control"
                    v-if="newCoupon.discount_method === 'minus'"
                    min="1"
                    step="1"
                    v-model="newCoupon.discount_index"
                    required>
                    <input type="number" class="form-control"
                    v-if="newCoupon.discount_method === 'times'"
                    min="0"
                    max="1"
                    step="0.1"
                    v-model="newCoupon.discount_index"
                    required>
                  </div>
                </div>
                <hr>
                <div class="card-body p-0 d-flex justify-content-end">
                  <button class="btn btn-success mr-3" type="submit">
                    新增優惠券
                  </button>
                  <button class="btn btn-warning" type="button"
                  @click.prevent="create_new_coupon">
                    清除重填
                  </button>
                </div>
              </form>
            </b-card>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coupons: [],
      newCoupon2: {
        id: '',
        description: '',
        availableLogic(order) {
          return order;
        },
        discount: 0,
        discountLogic(order) {
          return order;
        },
      },
      newCoupon: {
        id: '',
        description: '',
        discount_method: '',
        discount_index: 0,
        discount: 0,
      },
    };
  },
  methods: {
    initialize_coupons() {
      let arr;
      this.$bus.$on('son_get_data', (data) => {
        arr = data.coupons;
      });
      this.$bus.$emit('son_call_data');
      arr.forEach((item, index) => {
        arr[index].editing = false;
      });
      this.coupons = JSON.parse(JSON.stringify(arr));
    },
    create_new_coupon() {
      this.newCoupon = {
        id: '',
        description: '',
        discount_method: '',
        discount_index: 0,
        discount: 0,
      };
    },
    convert_discount_method(method) {
      let chinese = '';
      switch (method) {
        case 'minus':
          chinese = '原價減去';
          break;
        case 'times':
          chinese = '原價打折';
          break;
        default:
          break;
      }
      return chinese;
    },
    start_editing(couponIndex) {
      const otherEditing = this.coupons.find((item) => item.editing === true);
      if (otherEditing === undefined) {
        this.coupons[couponIndex].editing = true;
      } else {
        this.$bus.$emit('show_toast', 'warning', '一次只能進行一個優惠券編輯');
      }
    },
    complete_editing(couponIndex) {
      const tObj = JSON.parse(JSON.stringify(this.coupons[couponIndex]));
      delete tObj.editing;
      this.$bus.$emit('edit_coupon', tObj, couponIndex);
      this.initialize_coupons();
    },
    delete_coupon(couponIndex) {
      this.$bus.$emit('delete_coupon', couponIndex);
      this.initialize_coupons();
    },
    submit_new_coupon() {
      const newC = JSON.parse(JSON.stringify(this.newCoupon));
      this.$bus.$emit('add_new_coupon', newC);
      this.create_new_coupon();
      this.initialize_coupons();
    },
  },
  created() {
    this.initialize_coupons();
  },
};
</script>
